<div class="pesquisar-input">
  <p-floatlabel variant="on" class="w-full md:w-15rem">
    <p-iconfield iconPosition="right" class="w-full md:w-15rem">
      <input
        pSize="small"
        pInputText
        #search
        class="w-full md:w-15rem"
        id="search"
        type="text"
        (input)="onSearchChange($event.target.value)"
        autocomplete="off"
        [disabled]="disabled"
        />
      @if (search.value) {
        <p-inputicon>
          <i
            class="pi pi-times-circle cursor-pointer icon-clear"
            pTooltip="Limpar"
            tooltipPosition="bottom"
            (click)="search.value = ''; onSearchChange('')"
          ></i>
        </p-inputicon>
      }
    </p-iconfield>
      <label class="text-sm" for="search">
        <i class="pi pi-search text-xs"></i>
        Pesquisar nas linhas retornadas
      </label>
    </p-floatlabel>
  </div>
